<template>
  <!-- 该组件为 blog 页面组件 -->
  <div class="blog-list pl-60 pr-60">
    <ul class="d-f jc-sb">
      <li v-for="(item, index) in blogData" class="cu-p" :key="item.id" @click="gotoRoute(item.url, item.id)">
        <div class="blog-img-box">
          <a class="d-b h-100p" href="javascript:;">
            <img class="blog-img" v-lazy="item.coverImg" width="100%" height="100%" :alt="item.title" />
          </a>
        </div>
        <div class="blog-text ov-h">
          <h3 class="blog-title fs-20 ellipsis wlc-2 lh-15 m-0">
            <a href="javascript:;" class="blog-title-text">{{ item.title }}</a>
          </h3>

          <div class="blog-desc fs-16 ellipsis wlc-3 lh-15 c-777">
            {{ item.introduction }}
          </div>
          <div class="date-share d-f ai-c jc-sb p-r">
            <strong class="d-f ai-c c-999 fs-16 fw-400"
              ><i class="date-icon d-ib bgs-cover"></i> <span>{{ item.releaseTime | formatDate }}</span></strong
            >
            <div class="share-box d-f ai-c">
              <div
                class="share-container"
                v-show="showShareWrap && activeIndex === index"
                @mouseenter="mouseenterShare(index)"
                @mouseleave="mouseleaveShare"
              >
                <a
                  v-for="(shareItem, idx) in shareIcon"
                  :key="idx"
                  href="javascript:;"
                  :data-site="shareItem.site"
                  :class="shareItem.className"
                  @click.stop="processShare(shareItem.site)"
                  class="d-ib bgs-cover"
                ></a>
              </div>
              <div
                class="share-ico d-ib c-p bgs-cover"
                @mouseenter="mouseenterShare(index)"
                @mouseleave="mouseleaveShare"
              ></div>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <div class="more-btn d-n ta-c fs-16 m-a"><a href="javascript:;">Load More</a></div>
  </div>
</template>

<script>
  export default {
    props: {
      blogData: {
        type: Array,
        default: () => []
      },
      showLoadMore: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        showShareWrap: false,
        timer: null,
        activeIndex: -1,
        shareIcon: [
          {
            site: 'facebook',
            className: 'facebook-black'
          },
          {
            site: 'linkedin',
            className: 'linkedin-black'
          },
          {
            site: 'twitter',
            className: 'twitter-black'
          }
        ]
      }
    },
    created() {},
    mounted() {},
    methods: {
      mouseenterShare(index) {
        this.activeIndex = index
        console.log('[ index,this.activeIndex ] >', index, this.activeIndex)
        if (this.timer) clearTimeout(this.timer)

        this.showShareWrap = true
        // console.log('[ this.getMetaContent() ] >', this.getMetaContent('keywords'))
      },
      mouseleaveShare() {
        this.timer = setTimeout(() => {
          this.showShareWrap = false
        }, 100)
      },
      processShare(key) {
        const options = {
          url: document.location.href || '',
          title: document.title || '',
          desc: this.getMetaContent('description') || '',
          source: 'fjdynamics',
          origin: location.origin || ''
        }

        const siteMap = {
          facebook: `https://www.facebook.com/sharer/sharer.php?u=${options.url}&t=${options.title}`,
          linkedin: `http://www.linkedin.com/shareArticle?mini=true&ro=true&title= ${options.title}&url= ${options.url}&summary= ${options.desc}&source= ${options.source}&armin=armin`,
          twitter: `https://twitter.com/intent/tweet?text=${options.title}&url=${options.url}&via=${options.origin}`
        }
        this.openWindow(siteMap[key])
      },
      openWindow(url) {
        const ww = document.documentElement.clientWidth
        const wh = document.documentElement.clientHeight
        const iWidth = ww * 0.5
        const iHeight = wh * 0.7
        const iLeft = Number(ww - iWidth) / 2
        const iTop = Number(wh - iHeight) / 2

        window.open(
          url,
          '',
          'width=' +
            iWidth +
            ',height=' +
            iHeight +
            ',top=' +
            iTop +
            ',left=' +
            iLeft +
            ',toolbar=no, menubar=no, scrollbars=no, resizable=no,location=no, status=no'
        )
      },
      getMetaContent(key) {
        const metas = document.getElementsByTagName('meta')
        return metas[key]['content'] || ''
      },
      gotoRoute(url, id) {
        console.log('[ {url, id} ] >', { url, id })
        this.$router.push({ path: `/blog/${url}`, params: { id } })
      }
    }
  }
</script>

<style scoped lang="scss">
  .blog-list {
    padding-top: 0.6rem;
  }
  .blog-list ul {
    margin-bottom: 0.7rem;
    flex-wrap: wrap;
    justify-content: flex-start;
  }
  .blog-list li {
    margin-left: 0.3rem;
    width: 5.7rem;
    transition: transform 0.3s linear, border-color 0.3s linear;
    margin-bottom: 0.3rem;
    box-sizing: border-box;
    border: 1px solid #e5e5e5;
  }
  .blog-list li:nth-of-type(3n + 1) {
    margin-left: 0;
  }
  .blog-list li:hover {
    box-shadow: 0px 2px 16px 0px #eceaea;
    transform: scale(1.01);
    border-color: transparent;
  }
  .blog-img-box {
    height: 3.44rem;
  }
  .blog-text {
    transition: border 0.3s linear;
    padding: 0 0.3rem 0.5rem 0.3rem;
  }
  .blog-title {
    margin-top: 0.3rem;
    height: 60px;
    font-weight: 500;
  }
  .blog-desc {
    margin-bottom: 0.4rem;
    margin-top: 0.24rem;
    height: 100px;
  }
  .date-share {
    height: 35px;
  }
  .blog-desc::before {
    width: 0.6rem;
    margin-bottom: 0.3rem;
    content: '';
    display: block;
    height: 1px;
    background-color: #ababab;
  }
  .date-icon {
    width: 24px;
    height: 24px;
    margin-top: -0.03rem;
    margin-right: 0.12rem;
  }
  .share-ico {
    transition: transform 0.3s;
    width: 24px;
    height: 24px;
    margin-left: 0.1rem;
  }
  .share-ico:hover {
    transform: scale(1.2);
  }
  .share-container {
    margin-top: 0.06rem;
  }
  .share-container a {
    transition: transform 0.3s;
    width: 25px;
    height: 25px;
    font-size: 0;
    margin: 0 0.1rem;
    background-size: contain;
    background-repeat: no-repeat;
  }
  .share-container a:hover {
    transform: scale(1.2);
  }
  .more-btn {
    width: 170px;
    margin-bottom: 80px;
    line-height: 40px;
    border: 1px solid #333;
  }
  .more-btn:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }
</style>
